import { Navigate } from "react-router-dom";

//Dashboard
import DashboardCrm from "../pages/Dashboard";

//pages
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import Settings from '../pages/Pages/Profile/Settings/Settings';

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile

import Profile from "pages/User/Profile";
import UserProfile from "../pages/Authentication/user-profile";

import RoleList from "pages/User/Role";
import UserList from "pages/User/User";

import Configuration from "pages/Configuration";

import ManagementInventory from "pages/Managements/Inventory";
import ManagementMedia from "pages/Managements/Media";

import AdsLog from "pages/AdsLog/TrackingLog";
import AdsLogURL from "pages/AdsLog/TrackingLogURL";
import ManagementApi from "pages/Managements/Api";
import MonitorScript from "pages/Monitor/MonitorScript";
import MonitorTraffic from "pages/Monitor/MonitorTraffic";
import ReportInventory from "pages/Reports/Inventory";
import ReportMedia from "pages/Reports/Media";
import ManagementAgency from "pages/Managements/Agency";
import AdminActivityLogs from "pages/Logging/AdminActivityLogs";
import IPStatistic from "pages/Statistics/IPStatistic";
import ReportAgency from "pages/Reports/Agency";
import ManagementProxy from "pages/Managements/Proxy";
import ReportRevenue from "pages/Reports/Revenue";
import UUIDStatistic from "pages/Statistics/UUIDStatistic";
import ReportCommission from "pages/Reports/Commission";
import DailyStatistic from "pages/Statistics/DailyStatistic";
import UUIDBlock from "pages/Monitor/UUID/UUIDBlock";
import HourlyStatistic from "pages/Statistics/HourlyStatistic";
import UUIDExcept from "pages/Monitor/UUID/UUIDExcept";
import MonitorConfiguration from "pages/Monitor/MonitorConfiguration";
import ReportSettlement from "pages/Reports/Settlement";
import ReportMediaV2 from "pages/Reports/MediaV2";
import ReportADPlatform from "pages/Reports/ADPlatform";
import ReportADType from "pages/Reports/ADType";
import IPExcept from "pages/Monitor/IP/IPExcept";
import IPBlock from "pages/Monitor/IP/IPBlock";
import ReferrerStatistic from "pages/Statistics/ReferrerStatistic";
import MediaStatistic from "pages/Statistics/MediaStatistic";
import ReportCoupang from "pages/Reports/Coupang";
import PathStatistic from "pages/Statistics/PathStatistic";
import MediaHourlyStatistic from "pages/Statistics/MediaHourlyStatistic";
import MediaDailyStatistic from "pages/Statistics/MediaDailyStatistic";
import ManagementAdvertiser from "pages/Managements/Advertiser";
import ManagementAdvertising from "pages/Managements/Advertising";
import ReportAdvertiser from "pages/Reports/Advertiser";
import ReportAdvertising from "pages/Reports/Advertising";
import ReportMediaSales from "pages/Reports/MediaSales";
import MediaIPStatistic from "pages/Statistics/MediaIPStatistics";
import ReportCoupangNasmedia from "pages/Reports/CoupangNasmedia";
import ReportADPlatformSales from "pages/Reports/ADPlatformSales";
import ManagementADPlatform from "pages/Managements/ADPlatform";
import ReportADPlatformMedia from "pages/Reports/ADPlatformMedia";
import ReportClick from "pages/Reports/Click";
import ManagementAdvertiserAgency from "pages/Managements/AdvertiserAgency";
import ReportAdvertiserAgency from "pages/Reports/AdvertiserAgency";
import ReportInterwork from "pages/Reports/Interwork";
import KeywordStatistic from "pages/Statistics/KeywordStatistic";
import TitleStatistic from "pages/Statistics/TitleStatistic";
import UrlStatistic from "pages/Statistics/URLStatistic";
import DailyImpressionStatistic from "pages/Statistics/DailyImpressionStatistic";
import ReportDable from "pages/Reports/Dable";
import ReportDailyInterwork from "pages/Reports/InterworkDaily";
import ReportDailyDable from "pages/Reports/DableDaily";
import ManagementSSPMedia from "pages/Managements/SSPMedia";
import ManagementCoupang from "pages/Managements/Coupang";
import PageStatistic from "pages/Statistics/PageStatistic";
import ReportInventoryType from "pages/Reports/InventoryType";
import ReportCredential from "pages/Reports/Credential";
import ReportTrackingCode from "pages/Reports/TrackingCode";
import ReportMediaImpression from "pages/Reports/MediaImpression";
import ManagementDomain from "pages/Managements/Domain";
import ReportAgencyClick from "pages/Reports/AgencyClick";
import DUIDCountStatistic from "pages/Statistics/DUIDCountStatistic";
import DUIDStatistic from "pages/Statistics/DUIDStatistic";
import MonitorIP from "pages/Monitor/MonitorIP";
import IPCountStatistic from "pages/Statistics/IPCountStatistic";
const ROUTES = {
  DASHBOARD: '/dashboard',

  PROFILE: '/profile',
  PROFILE_SETTING: '/pages-profile-settings',

  USER_LIST: '/user/list',
  USER_ROLE: '/user/role',
  USER_PROFILE: '/user/profile',
  MANAGEMENT_PROXY: '/user/proxy',

  ADMIN_ACTIVITY_LOGS: '/logging/admin-activity-logs',

  CONFIGURATION: '/configuration',

  MANAGEMENT_MEDIA: '/managements/media',
  MANAGEMENT_INVENTORY: '/managements/inventory',
  MANAGEMENT_DOMAIN: '/managements/domain',
  MANAGEMENT_AGENCY: '/managements/agency',
  MANAGEMENT_COUPANG: '/managements/coupang',
  MANAGEMENT_ADVERTISER_AGENCY: '/managements/advertiser-agency',
  MANAGEMENT_ADVERTISER: '/managements/advertiser',
  MANAGEMENT_ADVERTISING: '/managements/advertising',
  MANAGEMENT_AD_PLATFORM: '/managements/ad-platform',
  MANAGEMENT_API: '/managements/api',
  MANAGEMENT_SSP_MEDIA: '/ssp/ssp-media-managements',

  MONITOR_SCRIPT: '/monitor/monitor-script',
  MONITOR_TRAFFIC: '/monitor/monitor-traffic',
  MONITOR_IP: '/monitor/monitor-ip',
  UUID_BLOCKS: '/monitor/block-uuid',
  UUID_EXCEPT: '/monitor/except-uuid',
  IP_BLOCKS: '/monitor/block-ip',
  IP_EXCEPT: '/monitor/except-ip',
  MONITOR_CONFIGURATION: '/monitor/configuration',


  REPORT_MEDIA: '/reports/media',
  REPORT_MEDIA_IMPRESSION: '/reports/media-impression',
  REPORT_MEDIA_V2: '/reports/media-v2',
  REPORT_MEDIA_SALES: '/reports/media-sales',
  REPORT_INVENTORY: '/reports/inventory',
  REPORT_INVENTORY_TYPE: '/reports/inventory-type',
  REPORT_AD_PLATFORM: '/reports/ad-platform',
  REPORT_AD_PLATFORM_SALES: '/reports/ad-platform-sales',
  REPORT_AD_PLATFORM_MEDIA: '/reports/ad-platform-media',
  REPORT_AD_TYPE: '/reports/ad-type',
  REPORT_AGENCY: '/report/agency',
  REPORT_AGENCY_CLICK: '/report/agency-click',
  REPORT_REVENUE: '/report/revenue',
  REPORT_COMMISSION: '/report/commission',
  REPORT_SETTLEMENT: '/report/settlement',
  REPORT_COUPANG: '/report/coupang',
  REPORT_CREDENTIAL: '/report/api',
  REPORT_TRACKING_CODE: '/report/tracking-code',
  REPORT_ADVERTISER: '/report/advertiser',
  REPORT_ADVERTISING: '/report/advertising',
  REPORT_CLICK: '/report/click',
  REPORT_ADVERTISER_AGENCY: '/report/advertiser-agency',

  REPORT_INTERWORDS: '/ssp/interwords',
  REPORT_DAILY_INTERWORDS: '/ssp/daily-interwords',
  REPORT_DABLE: '/ssp/dable',
  REPORT_DAILY_DABLE: '/ssp/daily-dable',


  ADS_LOG: '/statistics/ads-log',
  ADS_LOG_URL: '/statistics/ads-log-url',
  KEYWORD_STATISTICS: '/statistics/keyword-statistics',
  TITLE_STATISTICS: '/statistics/title-statistics',
  URL_STATISTICS: '/statistics/url-statistics',
  DAILY_STATISTICS: '/statistics/daily-statistics',
  DAILY_IMPRESSION_STATISTICS: '/statistics/daily-impression-statistics',
  HOURLY_STATISTICS: '/statistics/hourly-statistics',
  MEDIA_HOURLY_STATISTICS: '/statistics/media-hourly-statistics',
  MEDIA_DAILY_STATISTICS: '/statistics/media-daily-statistics',
  REFERRAL_STATISTICS: '/statistics/referrer-statistics',
  MEDIA_STATISTICS: '/statistics/media-statistics',
  PATH_STATISTICS: '/statistics/path-statistics',
  MEDIA_IP_STATISTICS: '/statistics/media-ip-statistics',
  REPORT_COUPANG_NASMEDIA: '/lab/coupang-nasmedia',

  IP_STATISTICS: '/statistics/ip-statistics',
  IP_COUNT_STATISTICS: '/statistics/ip-count-statistics',

  UUID_STATISTICS: '/statistics/uuid-statistics',
  DUID_STATISTICS: '/statistics/duid-statistics',
  DUID_COUNT_STATISTICS: '/statistics/duid-count-statistics',

  PAGE_STATISTICS: '/statistics/page-statistics', // page statistics


}

const authProtectedRoutes = [
  { path: ROUTES.DASHBOARD, component: <DashboardCrm /> },

  { path: ROUTES.PROFILE_SETTING, component: <Settings /> },
  { path: ROUTES.PROFILE, component: <UserProfile /> },

  // { path: ROUTES.USER_LIST, component: <UserList /> },
  // { path: ROUTES.USER_ROLE, component: <RoleList /> },
  { path: ROUTES.USER_PROFILE, component: <Profile /> },

  // { path: ROUTES.CONFIGURATION, component: <Configuration /> },

  // { path: ROUTES.MANAGEMENT_ADVERTISER, component: <ManagementAdvertiser /> },
  // { path: ROUTES.MANAGEMENT_ADVERTISING, component: <ManagementAdvertising /> },
  // { path: ROUTES.MANAGEMENT_AD_PLATFORM, component: <ManagementADPlatform /> },
  { path: ROUTES.MANAGEMENT_MEDIA, component: <ManagementMedia /> },
  { path: ROUTES.MANAGEMENT_INVENTORY, component: <ManagementInventory /> },
  // { path: ROUTES.MANAGEMENT_AGENCY, component: <ManagementAgency /> },
  // { path: ROUTES.MANAGEMENT_DOMAIN, component: <ManagementDomain /> },
  // { path: ROUTES.MANAGEMENT_ADVERTISER_AGENCY, component: <ManagementAdvertiserAgency /> },
  // { path: ROUTES.MANAGEMENT_API, component: <ManagementApi /> },
  // { path: ROUTES.MANAGEMENT_PROXY, component: <ManagementProxy /> },
  // { path: ROUTES.MANAGEMENT_SSP_MEDIA, component: <ManagementSSPMedia /> },
  { path: ROUTES.MANAGEMENT_COUPANG, component: <ManagementCoupang /> },


  // { path: ROUTES.REPORT_MEDIA, component: <ReportMedia /> },
  // { path: ROUTES.REPORT_MEDIA_IMPRESSION, component: <ReportMediaImpression /> },
  // { path: ROUTES.REPORT_MEDIA_V2, component: <ReportMediaV2 /> },
  // { path: ROUTES.REPORT_MEDIA_SALES, component: <ReportMediaSales /> },
  { path: ROUTES.REPORT_INVENTORY, component: <ReportInventory /> },
  // { path: ROUTES.REPORT_INVENTORY_TYPE, component: <ReportInventoryType /> },
  // { path: ROUTES.REPORT_AD_PLATFORM, component: <ReportADPlatform /> },
  // { path: ROUTES.REPORT_AD_PLATFORM_SALES, component: <ReportADPlatformSales /> },
  // { path: ROUTES.REPORT_AD_PLATFORM_MEDIA, component: <ReportADPlatformMedia /> },
  // { path: ROUTES.REPORT_AD_TYPE, component: <ReportADType /> },
  // { path: ROUTES.REPORT_AGENCY, component: <ReportAgency /> },
  // { path: ROUTES.REPORT_AGENCY_CLICK, component: <ReportAgencyClick /> },
  // { path: ROUTES.REPORT_REVENUE, component: <ReportRevenue /> },
  // { path: ROUTES.REPORT_COUPANG, component: <ReportCoupang /> },
  // { path: ROUTES.REPORT_CREDENTIAL, component: <ReportCredential /> },
  // { path: ROUTES.REPORT_TRACKING_CODE, component: <ReportTrackingCode /> },
  // { path: ROUTES.REPORT_COMMISSION, component: <ReportCommission /> },
  // { path: ROUTES.REPORT_SETTLEMENT, component: <ReportSettlement /> },
  // { path: ROUTES.REPORT_ADVERTISER, component: <ReportAdvertiser /> },
  // { path: ROUTES.REPORT_ADVERTISER_AGENCY, component: <ReportAdvertiserAgency /> },
  // { path: ROUTES.REPORT_INTERWORDS, component: <ReportInterwork /> },
  // { path: ROUTES.REPORT_DAILY_INTERWORDS, component: <ReportDailyInterwork /> },
  // { path: ROUTES.REPORT_DABLE, component: <ReportDable /> },
  // { path: ROUTES.REPORT_DAILY_DABLE, component: <ReportDailyDable /> },
  // { path: ROUTES.REPORT_ADVERTISING, component: <ReportAdvertising /> },
  // { path: ROUTES.REPORT_COUPANG_NASMEDIA, component: <ReportCoupangNasmedia /> },
  // { path: ROUTES.REPORT_CLICK, component: <ReportClick /> },

  // { path: ROUTES.DAILY_STATISTICS, component: <DailyStatistic /> },
  // { path: ROUTES.DAILY_IMPRESSION_STATISTICS, component: <DailyImpressionStatistic /> },
  // { path: ROUTES.KEYWORD_STATISTICS, component: <KeywordStatistic /> },
  // { path: ROUTES.TITLE_STATISTICS, component: <TitleStatistic /> },
  // { path: ROUTES.URL_STATISTICS, component: <UrlStatistic /> },
  // { path: ROUTES.HOURLY_STATISTICS, component: <HourlyStatistic /> },
  // { path: ROUTES.MEDIA_HOURLY_STATISTICS, component: <MediaHourlyStatistic /> },
  // { path: ROUTES.MEDIA_DAILY_STATISTICS, component: <MediaDailyStatistic /> },
  // { path: ROUTES.REFERRAL_STATISTICS, component: <ReferrerStatistic /> },
  // { path: ROUTES.MEDIA_STATISTICS, component: <MediaStatistic /> },
  // { path: ROUTES.PATH_STATISTICS, component: <PathStatistic /> },
  // { path: ROUTES.PAGE_STATISTICS, component: <PageStatistic /> },


  // { path: ROUTES.ADS_LOG, component: <AdsLog /> },
  // { path: ROUTES.ADS_LOG_URL, component: <AdsLogURL /> },
  // { path: ROUTES.MONITOR_SCRIPT, component: <MonitorScript /> },
  // { path: ROUTES.MONITOR_TRAFFIC, component: <MonitorTraffic /> },
  // { path: ROUTES.MONITOR_IP, component: <MonitorIP /> },
  // { path: ROUTES.IP_STATISTICS, component: <IPStatistic /> },
  // { path: ROUTES.IP_COUNT_STATISTICS, component: <IPCountStatistic /> },
  // { path: ROUTES.MEDIA_IP_STATISTICS, component: <MediaIPStatistic /> },
  // { path: ROUTES.UUID_STATISTICS, component: <UUIDStatistic /> },
  // { path: ROUTES.DUID_STATISTICS, component: <DUIDStatistic /> },
  // { path: ROUTES.DUID_COUNT_STATISTICS, component: <DUIDCountStatistic /> },
  // { path: ROUTES.UUID_EXCEPT, component: <UUIDExcept /> },
  // { path: ROUTES.UUID_BLOCKS, component: <UUIDBlock /> },
  // { path: ROUTES.IP_EXCEPT, component: <IPExcept /> },
  // { path: ROUTES.IP_BLOCKS, component: <IPBlock /> },
  // { path: ROUTES.MONITOR_CONFIGURATION, component: <MonitorConfiguration /> },


  // { path: ROUTES.ADMIN_ACTIVITY_LOGS, component: <AdminActivityLogs /> },


  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={ROUTES.DASHBOARD} />,
  },
  { path: "*", component: <Navigate to={ROUTES.DASHBOARD} /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  //AuthenticationInner pages
  { path: "/pages-coming-soon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes, ROUTES };

